<div class="flex-direction-column gap-8 padding-15px">
  <span class="weight-600 font-14" style="margin-bottom: 11px">Cadastrar/Editar Perfil</span>

  <app-form-field label="Nome" colorLabel="black" [value]="perfil.nome" heightFormField="30px" (changeValue)="perfil.nome = $event; alteracaoService.camposAlterado()"></app-form-field>
  <div class="flex-direction-row gap-10 align-center">
    <mat-slide-toggle [(ngModel)]="perfil.ativo" (ngModelChange)="alteracaoService.camposAlterado()">Status</mat-slide-toggle>
    <mat-slide-toggle [(ngModel)]="perfil.admin" (ngModelChange)="alteracaoService.camposAlterado()">Admin</mat-slide-toggle>
  </div>

  <div class="flex-direction-column justify-center gap-5">
    <app-button-padrao label="Salvar" backgroundColor="var(--verde-padrao)" fontWeight="600" width="100%" (buttonClick)="salvar()"></app-button-padrao>

    <app-button-padrao label="Cancelar" color="#BD1D00" backgroundColor="white" borderColor="#BD1D00" borderStyle="solid"
       borderWidth="2px" fontWeight="600" width="100%" (buttonClick)="cancelar()"></app-button-padrao>
  </div>
</div>
